export const dropboxOptions = [
  {
    label: ',',
    value: ',',
  },
  {
    label: '_',
    value: '_',
  },
  {
    label: '.',
    value: '.',
  },
  {
    label: '&',
    value: '&',
  },
  {
    label: '-',
    value: '-',
  },
  {
    label: ',',
    value: ',',
  },
  {
    label: ';',
    value: ';',
  },
  {
    label: ':',
    value: ':',
  },
  {
    label: '|',
    value: '|',
  },
  {
    label: '/',
    value: '/',
  },
];
